<template>
  <v-form class="pa-6">
    <h3 class="text-left mb-1 text-primary">Create Credential</h3>
    <p class="text-caption mb-4">Elegí los segundos factores habilitados para la nueva credencial.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
        size="small"
        color="primary"
        @click="createCredential"
        :disabled="multisign == '' || !(enabledEmail || enabledOTP || enabledPIN || enabledSMS || enabledWebAuthn)">
        Create
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <h4 class="text-start mb-2">Second factors:</h4>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-checkbox
          class="mt-0 pt-0"
          v-model="enabledPIN"
          label="PIN"
        ></v-checkbox>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-checkbox
          class="mt-0 pt-0"
          v-model="enabledOTP"
          label="OTP"
        ></v-checkbox>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-checkbox
          class="mt-0 pt-0"
          v-model="enabledSMS"
          label="SMS"
        ></v-checkbox>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-checkbox
          class="mt-0 pt-0"
          v-model="enabledEmail"
          label="Email"
        ></v-checkbox>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-checkbox
          class="mt-0 pt-0"
          v-model="enabledWebAuthn"
          label="WebAuthn"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="multisign"
          label="Multisign"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex';
import alisonServer from  '../services/alisonServer.js';
  export default {
    props:["data", "config", "serverConfig"],
    data: () => ({
      multisign: '15',
      enabledPIN: false,
      enabledOTP: false,
      enabledSMS: false,
      enabledEmail: false,
      enabledWebAuthn: false,
    }),
    mounted(){
    },
    watch:{

    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async createCredential() {
        if (this.serverConfig === null || this.serverConfig.generationAccessToken === undefined) {
          this.setColor('error');
          this.setSnack('Missing generation token');
          return;
        }
        const seatId = this.serverConfig.seatId;
        const credentialData = {
          multisign: this.multisign,
          webauthn: this.enabledWebAuthn,
          pin: this.enabledPIN,
          sms: this.enabledSMS,
          email: this.enabledEmail,
          otp: this.enabledOTP,
        };
        try {
          const credentialId = await alisonServer.createCredential(seatId, credentialData);
          this.$emit("setServerConfig", {
            credential: {
              id: credentialId,
              ...credentialData,
            },
          })
          this.setColor('success');
          this.setSnack('Credential ' + credentialId + " generated");
        } catch (e) {
          this.setColor('error');
          this.setSnack(e);
          console.log(e);
        }
      }
    },
  }
</script>
